import { render, staticRenderFns } from "./banModal.vue?vue&type=template&id=1d86c51d&"
import script from "./banModal.vue?vue&type=script&lang=js&"
export * from "./banModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports